import type { Role } from "../types/roles";

type RolePermission = {
  isHost: boolean;
};

export const ROLE_PERMISSIONS: Record<Role, RolePermission> = {
  Judge: { isHost: true },
  Reader: { isHost: true },
  Controller: { isHost: true },
  Advocate: { isHost: false },
  Individual: { isHost: false },
  SuperAdmin: { isHost: false },
};

/**
 * Check if role is Host
 */
export const isHostRole = (role?: Role): boolean => {
  if (!role) return false;
  return ROLE_PERMISSIONS[role]?.isHost ?? false;
};

export function loginRedirectPath(path: string) {
  return `/login?redirect=${encodeURIComponent(path)}`;
}

export function getSafeRedirectPath(path?: string | null) {
  if (!path) return null;

  try {
    const decoded = decodeURIComponent(path);
    if (!decoded.startsWith("/") || decoded.startsWith("//")) return null;
    return decoded;
  } catch {
    return null;
  }
}
